import { Navigate } from "react-router-dom";
import { useUsuario } from "../../../providers/usuarioProvider";
import { PropsWithChildren } from "react";

export default function RootRedirectRoute({}: PropsWithChildren) {
  const { isLoading, isAuthenticated } = useUsuario();

  if (isLoading) {
    return null;
  }

  if (isAuthenticated) {
    return <Navigate to="/painel" replace />;
  } else {
    return <Navigate to="/login" replace />;
  }
}
